var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTubeIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 755.64 682.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#344d5f;stroke-linecap:round;stroke-linejoin:round;stroke-width:34px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360,152.58v-54M360,17a40.47,40.47,0,1,1-40.47,40.47A40.47,40.47,0,0,1,360,17ZM516.56,57.47H399.71m-79.52,0H203.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.53,343.77c57.84,27.26,89.53,27.61,102.06,40.54s9,36.65-7.83,53-40.67,19.07-53.19,6.14.27-61.05-41-99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.86,176.69V407m9-199.18H539.27M586.14,474c.94-22.84.18-34.65-3.66-48.7-7.22-26.42-25.47-38.32-64.08-39-47.17-.87-266.19,1.69-313.83,1.69H76.25m233-197.38V169.89a17.36,17.36,0,0,1,17.31-17.31H386m0,0h9.51a17.37,17.37,0,0,1,17.3,17.31v20.67M539.87,178V378.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M737.89,578.5c-39,0-73-24.16-90.11-59.62-17.14,35.46-51.06,59.62-90.11,59.62s-73-24.16-90.11-59.62c-17.14,35.46-51.07,59.62-90.12,59.62s-73-24.16-90.1-59.62c-17.14,35.46-51.07,59.62-90.12,59.62s-73-24.16-90.1-59.62C90,554.34,56.05,578.5,17,578.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M738.64,665.25c-39,0-73-24.16-90.1-59.62-17.15,35.46-51.07,59.62-90.12,59.62s-73-24.16-90.11-59.62c-17.14,35.46-51.06,59.62-90.11,59.62s-73-24.16-90.11-59.62C271,641.09,237,665.25,198,665.25s-73-24.16-90.11-59.62c-17.14,35.46-51.06,59.62-90.11,59.62"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeIco);
export default __webpack_public_path__ + "static/media/tube-ico.cb81af21.svg";
export { ForwardRef as ReactComponent };